import {Repository, createRepository} from '@/repositories/Base/Repository'

class VnsMonitorRepository extends Repository {
    endpoint = 'integration/monitor/vns'

    fetchAll(params) {
        return this.$axios.get(`vam/vns`, params)
    }

    fetchStatus({vnsId, minutes = 10}) {
        return this.$axios.get(`${this.endpoint}/${vnsId}/status/${minutes}`)
    }

    fetchStatusToMonitor() {
        return this.$axios.get(`${this.endpoint}/statusToMonitor`)
    }

    fetchJiraToMonitor() {
        return this.$axios.get(`${this.endpoint}/jiraToMonitor`)
    }

    fetchLatestsJira(vnsId) {
        return this.$axios.get(`${this.endpoint}/latestsJira/${vnsId}`)
    }

    fetchLastStatus(vnsId) {
        return this.$axios.get(`${this.endpoint}/${vnsId}/latestStatus`)
    }

    fetchSensor(params) {
        return this.$axios.get(`${this.endpoint}/${params.vnsId}/sensor`, {params})
    }

    fetchWifi(id) {
        return this.$axios.get(`${this.endpoint}/${id}/wifiLocation`)
    }

    fetchLog(id) {
        return this.$axios.get(`${this.endpoint}/${id}/log`,)
    }

    fetchIp(params) {
        return this.$axios.get(`${this.endpoint}/${params.vnsId}/ip`, {params})
    }

    fetchLastIp(vnsId) {
        return this.$axios.get(`${this.endpoint}/${vnsId}/latestIp`)
    }

    fetchLastGeoLocation(id) {
        return this.$axios.get(`${this.endpoint}/${id}/latestGeoLocation`,)
    }
}

export default new VnsMonitorRepository()

export const create = createRepository(VnsMonitorRepository)
